"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiveAnalyticsTrackingContext = void 0;
const tslib_1 = require("tslib");
// disable-ts-expect-error
const react_1 = tslib_1.__importStar(require("react"));
/**
 * HiveAnalyticsTrackingProvider is a React component that provides the HiveAnalyticsTrackingContext
 * to its child components. It manages a set of fired events and exposes methods to add, remove,
 * check the status of, and clear these events.
 *
 * Key is used as a unique identifier for each event.
 *
 *
 * @param {ReactNode} children - The child components that will have access to the context.
 * @returns {ReactElement} The provider component that wraps the children with the HiveAnalyticsTrackingContext.
 *
 * ## Example Usage
 * ```tsx
 * <HiveAnalyticsTrackingProvider>
 *   <YourComponent />
 * </HiveAnalyticsTrackingProvider>
 * ```
 *
 * Inside `YourComponent`, you can use the context as follows:
 * ```tsx
 * const { addHiveEvent, getHiveEventStatus } = useContext(HiveAnalyticsTrackingContext)
 * addHiveEvent('eventKey')
 * console.log(getHiveEventStatus('eventKey')) // Outputs: 'FIRED'
 * ```
 */
exports.HiveAnalyticsTrackingContext = (0, react_1.createContext)({
    addHiveEvent: () => { },
    removeHiveEvent: () => { },
    getHiveEventStatus: () => 'DISABLED',
    clearAllHiveEvents: () => { }
});
const HiveAnalyticsTrackingProvider = ({ children }) => {
    const firedEventsSetRef = (0, react_1.useRef)(new Set());
    const addHiveEvent = (key) => {
        const firedEventsSet = firedEventsSetRef.current;
        firedEventsSet.add(key);
    };
    const removeHiveEvent = (key) => {
        const firedEventsSet = firedEventsSetRef.current;
        firedEventsSet.delete(key);
    };
    const getHiveEventStatus = (key) => {
        const firedEventsSet = firedEventsSetRef.current;
        return firedEventsSet.has(key) ? 'FIRED' : 'NOT_FIRED';
    };
    const clearAllHiveEvents = () => {
        firedEventsSetRef.current.clear();
    };
    return (react_1.default.createElement(exports.HiveAnalyticsTrackingContext.Provider, { value: { addHiveEvent, getHiveEventStatus, clearAllHiveEvents, removeHiveEvent } }, children));
};
exports.default = HiveAnalyticsTrackingProvider;
//# sourceMappingURL=HiveAnalyticsTrackingProvider.js.map